var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDot(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#41AAAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDot);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/greenDot.4f235c3e.svg";
export { MemoForwardRef as ReactComponent };